/* eslint-disable array-callback-return */
/* eslint-disable func-names */
import React, { useState, useContext } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import withForm from 'modules/common/hoc/withForm';
import { ModalContext } from 'App';
import Modal from 'modules/common/components/Modal';
import * as actions from '../actions';
import * as c from '../constants';

const formatData = info => {
  const newArr = [];
  info.map(res => {
    if (res.attributes.amount) {
      newArr.push({
        label: res.attributes.amount,
        value: res.attributes.amount,
      });
    }
  });
  return _.uniqBy(newArr, function(e) {
    return e.label;
  });
};

function ChangeAmount({
  setFormData,
  formData,
  logs,
  transactionId,
  updating,
  changeAmount,
  onClear,
}) {
  const setModal = useContext(ModalContext);
  const [isDisabled, setIsDisabled] = useState(true);
  const logData = formatData(_.get(logs, 'res.data'));

  const handleOnChangeSelect = key => e => {
    setIsDisabled(false);
    setFormData({
      ...formData,
      transaction_history_id: transactionId,
      [key]: { label: e.value, value: e.value },
    });
  };

  const handleSubmit = e => {
    e.preventDefault();
    const args = {
      ...formData,
      amount: _.get(formData, 'amount.value').replace(/,/g, ''),
    };
    changeAmount(args, () => {
      onClear(e);
      setModal({ isOpen: false });
    });
  };

  return (
    <Modal.Body>
      <div className="row">
        <div className="col-12 form-group">
          <label className="form-label d-flex align-items-center">
            <span className="mr-auto mr-0 text-muted">Transaction</span>
          </label>
          <Select
            placeholder=""
            onChange={handleOnChangeSelect('amount')}
            options={logData}
            value={_.get(formData, 'amount')}
          />
        </div>
        <div className="col-12 d-flex justify-content-center mt-2">
          <button
            disabled={isDisabled || updating}
            onClick={handleSubmit}
            type="button"
            className="btn btn-primary cms-bg-color-primary cms-outline-primary "
          >
            Submit
          </button>
        </div>
      </div>
    </Modal.Body>
  );
}

ChangeAmount.propTypes = {
  formData: PropTypes.instanceOf(Object).isRequired,
  changeAmount: PropTypes.instanceOf(Object).isRequired,
  logs: PropTypes.instanceOf(Object).isRequired,
  transactionId: PropTypes.string.isRequired,
  onClear: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_AMOUNT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ChangeAmount);
